import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { provideLocationState } from "components/utility/hoc/LocationState";

var Spinner = require("components/utility/Spinner");
var CurrentUser = require("lib/account/CurrentUser");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var PicksPage = require("components/reading/picks/PicksPage");
var ExercisePage = require("components/writing/activities/ExercisePage")

var Features = require("lib/account/Features");
var AccountPlans = require("lib/account/AccountPlans");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");

var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

var ActivitiesPageRouting = require("lib/routing/ActivitiesPageRouting");

require("writing/activities/activities_page.scss");

@provideLocationState(ActivitiesPageRouting.getRouteState)
@connect(
	(state, props) => ({
		user: CurrentUser.get(),
		isLoadingLogs: ReadingSelectors.isLoadingLogs({ state }),
		product: CurrentUser.get().product,
		userIDs: _.pluck(RosterSelectors.students({ state }), "id"),
	}),
	(dispatch, props) => ({
		populateData: () => {
			return dispatch(RosterActions.fetchStudents({
				embeds: RosterActions.GLOBAL_STUDENT_EMBEDS
			}))
		},
	})
)
	
@providePopulateData({ waitForLoad: true })
class ActivitiesPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var selGradeLevel = $wr.getURLParameterByName("grade_level") || props.user.grade_level;
		this.assignTaskModal = React.createRef();
		this.AssignExerciseDetailsModal = React.createRef();

		this.state = {
			loading: false,
			view: EXERCISE_VIEW,
		};
	}
	
	hasQualifiedPlan() {
		var activeTrials = this.props.user.account.active_trials
		var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD]) ? true : false
		return this.props.product === 'wrGold' || hasQualifiedTrial ? true : false
	}

	isExerciseView() {
		return this.props.locationState.activeView == ActivitiesPageRouting.VIEWS.EXERCISE_VIEW;
	}

	switchActiveView(viewKey) {
		Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
		this.switchView({ activeView: viewKey });
	}

	switchView(change) {
		var newLocationState = _.extend({}, this.props.locationState, change);
		$wr.redirect(ActivitiesPageRouting.getPath(newLocationState));
	}

	render() {
		var lState = this.props.locationState;
		var pageClassName = "container activitiesPage";

		if (Features.isEnabled(Features.LOG_READING)) {
			var toggleOptions = [
				{ key: ActivitiesPageRouting.VIEWS.EXERCISE_VIEW, text: "Exercises" },
				{ key: ActivitiesPageRouting.VIEWS.TEACHER_PICKS_VIEW, text: "Teacher Picks" }
			]

			var pageHeaderText = this.hasQualifiedPlan() ? 'Activities' : 'Teacher Picks'

			var displayToggle = (
				<DisplayToggleControl options={toggleOptions} className="topToggle"
					onChange={this.switchActiveView}
					activeOptionKey={lState.activeView} />
			)

			var pageHeader = (
				<header className="pageHeader">
					<h1 className="hideOnPrint">{pageHeaderText}</h1>
				</header>
			)

			var displayToggleOptions = (
				<div className="hideOnPrint ">
					{pageHeader}
				</div>
			);

			if (this.hasQualifiedPlan()) {
				displayToggleOptions = (
					<div className="hideOnPrint ">
						{pageHeader}
						{displayToggle}
					</div>
				);
			}

			pageClassName += " withToggle";

		}
		if (this.isExerciseView() && this.hasQualifiedPlan()) {
			var pageContent = (
				<ExercisePage hasQualifiedPlan={this.hasQualifiedPlan()} userIDs={this.props.userIDs} />
			);

		} else {
			if (this.props.isLoadingLogs) {
				var pageContent = (
					<Spinner placeholder={true} scale={1.7} className="shelfSpin" />
				);

			} else {
				var pageContent = (
					<div className="teacherPicksWrap">
						<PicksPage userIDs={this.props.userIDs} hideTitle={true}/>
					</div>
				);
			}

		}
		return (
			<div className={pageClassName}>
				{ displayToggleOptions}
				{ pageContent}
			</div>
		)
	}
};

var EXERCISE_VIEW = "exercises";
var TEACHER_PICKS_VIEW = "teacher-picks";

module.exports = ActivitiesPage;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/ActivitiesPage.js